import { selectLanguage } from '../containers/App/selectors'
import messages from '../routes/messages'

/**
 * Function to bind component to `react-router-redux` route actions via initialized `store`.
 * @depreciated
 * @param {Store} store
 */
export const getRouteName = store => (route, nextState, replace) => {
  const language = selectLanguage(store.getState())
  nextState.routes[1].name = messages[route][language]
  return nextState
}
